import Addon from '../../../../shared/classes/addon';
import Content from '../../../../shared/types/enums/content';
import Tick from '../../atoms/icons/tickIcon';

function DescriptionAddonTick({ asset }: { asset: Addon }) {
  let hasAddon = false;
  if (asset?.type === Content.ADDON) {
    hasAddon = asset.checkAddon();
  }
  return hasAddon ? <Tick /> : <></>;
}

export default DescriptionAddonTick;
